import Component from '~/components/component';
import CookiesManager from '../../helpers/cookies-manager';

export default class Deprecated extends Component {
     constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }


    _retrieveDOM() {
        this.dom.container = this.dom.component;
        this.dom.close = this.dom.component.querySelector('.js-close-rotate');
    }

    init() {
        super.init();
        if( !CookiesManager.check('deprecatedBrowser') ) {
            this.dom.component.classList.add('show');
        }

    }

    bind() {
        super.bind();
        this.dom.close.addEventListener('click', () => {
            this.dom.component.classList.remove('show');
            CookiesManager.set('deprecatedBrowser', 1);
        });
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/deprecated/deprecated.js